import React, { useState, useEffect, useRef } from "react";
import FilterComponent, { FilterType } from "../dashboard/Filter";
import HotSpotInfoTable from "../../common/HotSpotInfoTable";
import PagePaginate from "../../common/PagePaginate";
import useClickOutside from "../../../hook/UseClickOutSide";
import Districts from "../../../Districts.json";
import Provinces from "../../../Provinces.json";
import SubDistrict from "../../../Subdistrict.json";
import Regions from "../../../Regions.json";
import _, { orderBy } from "lodash";
import {
  DashboardAPI,
  DashBoardParamsType,
} from "../../../api/dashboard/Dashboard";
import {
  AseanDataTableType,
  DashBoardResponseType,
  ThaiDataTableType,
} from "../dashboard/DashBoard";
import moment from "moment";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useLoading } from "../../../context/LoadingContext";

function Report() {
  const [hadData, setHadData] = useState(false);
  const [filterData, setFilterData] = useState<FilterType | undefined>();
  const [isOpenOptionDownLoad, setIsOpenOptionDownLoad] = useState(false);
  const [dataTable, setDataTable] = useState<any>();
  const [dataType, setDataType] = useState<"Thailand" | "Asean">("Thailand");
  const dropdownRef = useRef(null);
  const [tableColumnName, setTableColumnName] = useState("");
  const [oldDataTable, setOldDataTable] = useState<
    ThaiDataTableType[] | AseanDataTableType[]
  >([]);
  const [totalPage, setTotalPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  const [itemStart, setItemStart] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataDate, setDataDate] = useState<any>();
  const [dataTableTitle, setDataTableTitle] = useState("ระดับภูมิภาค");
  const { onSetLoading } = useLoading();

  const handleClickLoad = (val: boolean) => {
    setIsOpenOptionDownLoad(val);
  };
  const handleFilter = (data: FilterType | undefined) => {
    setFilterData(data);
  };
  const getDashboardTable = async (params: FilterType | undefined) => {
    try {
      onSetLoading(true);
      let payload: DashBoardParamsType = {};
      let provinceList: any = [];
      if (params === undefined) {
        let startOfDay = new Date().setHours(0, 0, 0, 0);
        let endOfDay = new Date().setHours(23, 59, 59, 999);
        let startDate = moment(startOfDay).add(7, "hours").unix();
        let endDate = moment(endOfDay).add(7, "hours").unix();

        payload = {
          instrument: "VIIRS",
          satellite: "Suomi NPP",
          ct_en: "Thailand",
          groupby: "re_royin,lu_code,status",
          aggregate: "count:id,max:updated_at",
          limit: 10000,
          timestamp: `${startDate}/${endDate}`,
        };
      } else if (params) {
        if (params.countryType?.id === 1) {
          payload = {
            ct_en: "Thailand",
            groupby: "re_royin,lu_code,status",
            aggregate: "count:id,max:updated_at",
            limit: 10000,
            file_name:
              params.fileName?.trim() !== "" ? params.fileName : undefined,
          };

          if (params.provinceGroup?.id === 2) {
            let northProvince = Provinces.filter(
              (e) => e.Group17Provinces === 1
            );
            payload.groupby = "pv_idn,pv_tn,lu_code,status";
            provinceList = northProvince;
          }

          if (params.region?.RegionCode !== "0") {
            payload.re_royin = params.region?.RegionCode;
            payload.groupby = "pv_idn,pv_tn,lu_code,status";
          }

          if (params.province && params.province.length > 0) {
            const hasProvinceCodeZero = params.province.some(
              (item) => item.ProvinceCode === "0"
            );
            if (!hasProvinceCodeZero) {
              payload.groupby = "ap_idn,ap_tn,lu_code,status";
              provinceList = params.province;
            }
          }

          if (params.district?.DistrictCode !== "0") {
            payload.ap_idn = params.district?.DistrictCode;
            payload.groupby = "tb_idn,tb_tn,lu_code,status";
          }

          if (params.subdistrict?.SubdistrictCode !== "0") {
            payload.tb_idn = params.subdistrict?.SubdistrictCode;
            payload.groupby = "tb_idn,tb_tn,lu_code,status";
          }
        } else {
          payload = {
            asian: 1,
            groupby: "ct_en,ct_tn,instrument,lu_code,status,max:updated_at",
            aggregate: "count:id,max:updated_at",
            file_name:
              params.fileName?.trim() !== "" ? params.fileName : undefined,
            limit: 10000,
          };
        }
        if (params.startDate && params.endDate === null) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.startDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.startDate && params.endDate) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.endDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.satellite === "VIIRS" || params.satellite === "MODIS") {
          payload.instrument = params.satellite;
        }
        if (
          params.satellite === "Suomi NPP" ||
          params.satellite === "NOAA-20"
        ) {
          payload.satellite = params.satellite;
        }
      }
      const data = (await DashboardAPI(
        payload,
        provinceList.length > 0 ? provinceList : undefined
      )) as DashBoardResponseType;
      if (data.items.length > 0) {
        let maxDate: any = _.maxBy(data.items, "max_updated_at");
        setDataDate(maxDate?.max_updated_at);
        if (!params) {
          let groupedDataItems: any = {
            Central: data.items.filter((e) => e.re_royin === "Central"),
            West: data.items.filter((e) => e.re_royin === "West"),
            East: data.items.filter((e) => e.re_royin === "East"),
            Northeast: data.items.filter((e) => e.re_royin === "Northeast"),
            North: data.items.filter((e) => e.re_royin === "North"),
            South: data.items.filter((e) => e.re_royin === "South"),
          };
          let arrayOfResult: any = [];
          _.forEach(Regions, (region) => {
            let dataInRegions = groupedDataItems[region.RegionCode];
            if (dataInRegions.length > 0) {
              let arrayOfLucode: any = {};
              let lu_code_1 = dataInRegions.filter((d: any) => d.lu_code === 1);
              let lu_code_2 = dataInRegions.filter((d: any) => d.lu_code === 2);
              let lu_code_3 = dataInRegions.filter((d: any) => d.lu_code === 3);
              let lu_code_4 = dataInRegions.filter((d: any) => d.lu_code === 4);
              let lu_code_5 = dataInRegions.filter((d: any) => d.lu_code === 5);
              let lu_code_6 = dataInRegions.filter((d: any) => d.lu_code === 6);
              if (lu_code_1.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_1, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_1 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_1 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }
              if (lu_code_2.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_2, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_2 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_2 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }
              if (lu_code_3.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_3, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_3 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_3 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }
              if (lu_code_4.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_4, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_4 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_4 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }
              if (lu_code_5.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_5, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_5 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_5 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }
              if (lu_code_6.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_6, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_6 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_6 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }

              let total = _.sum([
                arrayOfLucode?.lu_code_1 ? arrayOfLucode?.lu_code_1?.total : 0,
                arrayOfLucode?.lu_code_2 ? arrayOfLucode?.lu_code_2?.total : 0,
                arrayOfLucode?.lu_code_3 ? arrayOfLucode?.lu_code_3?.total : 0,
                arrayOfLucode?.lu_code_4 ? arrayOfLucode?.lu_code_4?.total : 0,
                arrayOfLucode?.lu_code_5 ? arrayOfLucode?.lu_code_5?.total : 0,
                arrayOfLucode?.lu_code_6 ? arrayOfLucode?.lu_code_6?.total : 0,
              ]);
              arrayOfResult.push({
                name: region.RegionName,
                total: total,
                lu_code_1: arrayOfLucode?.lu_code_1,
                lu_code_2: arrayOfLucode?.lu_code_2,
                lu_code_3: arrayOfLucode?.lu_code_3,
                lu_code_4: arrayOfLucode?.lu_code_4,
                lu_code_5: arrayOfLucode?.lu_code_5,
                lu_code_6: arrayOfLucode?.lu_code_6,
              });
            } else {
              arrayOfResult.push({
                name: region.RegionName,
                total: 0,
                lu_code_1: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
                lu_code_2: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
                lu_code_3: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
                lu_code_4: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
                lu_code_5: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
                lu_code_6: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
              });
            }
          });
          setDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
          setTableColumnName("ภูมิภาค");
          setTotalItems(arrayOfResult.length);
          setOldDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
          setDataType("Thailand");
        } else {
          if (params.countryType?.value === "ประเทศไทย") {
            if (
              (params?.district && params?.district?.DistrictCode !== "0") ||
              (params?.subdistrict &&
                params?.subdistrict?.SubdistrictCode !== "0")
            ) {
              let id = 0;
              let total = 0;
              const result: any = [];
              const groupedData = _.groupBy(
                data.items,
                (item) => `${item.tb_idn}_${item.lu_code}`
              );
              const counts: any = {};
              _.forEach(groupedData, (groupedItems, groupKey) => {
                const [tb_idn, lu_code] = groupKey.split("_");
                if (!counts[tb_idn]) {
                  counts[tb_idn] = {};
                }
                const luCodeObject = counts[tb_idn];
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };

                _.forEach(groupedItems, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                luCodeObject[`lu_code_${lu_code}`] = statusCounts;
              });
              _.forEach(counts, (luCodes, tb_idn) => {
                total = 0;
                total = _.sum([
                  luCodes?.lu_code_1 ? luCodes?.lu_code_1?.total : 0,
                  luCodes?.lu_code_2 ? luCodes?.lu_code_2?.total : 0,
                  luCodes?.lu_code_3 ? luCodes?.lu_code_3?.total : 0,
                  luCodes?.lu_code_4 ? luCodes?.lu_code_4?.total : 0,
                  luCodes?.lu_code_5 ? luCodes?.lu_code_5?.total : 0,
                  luCodes?.lu_code_6 ? luCodes?.lu_code_6?.total : 0,
                ]);

                const subdistrictInfo = _.find(SubDistrict, {
                  SubdistrictCode: tb_idn.toString(),
                });

                const districtInfo = _.find(Districts, {
                  DistrictCode: subdistrictInfo?.DistrictCode,
                });

                const provinceInfo = _.find(Provinces, {
                  ProvinceCode: districtInfo?.ProvinceCode,
                });

                const resultObject = {
                  id: id + 1,
                  name: subdistrictInfo ? subdistrictInfo.SubdistrictName : "",
                  districtName: districtInfo ? districtInfo.DistrictName : "",
                  provinceName: provinceInfo ? provinceInfo.ProvinceName : "",
                  ...luCodes,
                  total: total,
                };
                result.push(resultObject);
                id = id + 1;
              });

              let sortedData = result.sort((a: any, b: any) => {
                const provinceComparison = a.provinceName.localeCompare(
                  b.provinceName
                );
                const districtComparison =
                  provinceComparison === 0
                    ? a.districtName.localeCompare(b.districtName)
                    : provinceComparison;
                return districtComparison === 0
                  ? a.name.localeCompare(b.name)
                  : districtComparison;
              });
              setDataTable(sortedData);
              setTableColumnName("ตำบล");
              setTotalItems(sortedData.length);
              setOldDataTable(sortedData);
              setDataType("Thailand");
            } else if (
              params?.province &&
              params?.province[0].ProvinceCode !== "0"
            ) {
              let id = 0;
              let total = 0;
              const result: any = [];
              const groupedData = _.groupBy(
                data.items,
                (item) => `${item.ap_idn}_${item.lu_code}`
              );
              const counts: any = {};
              _.forEach(groupedData, (groupedItems, groupKey) => {
                const [ap_idn, lu_code] = groupKey.split("_");
                if (!counts[ap_idn]) {
                  counts[ap_idn] = {};
                }
                const luCodeObject = counts[ap_idn];
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };

                _.forEach(groupedItems, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                luCodeObject[`lu_code_${lu_code}`] = statusCounts;
              });
              _.forEach(counts, (luCodes, ap_idn) => {
                total = 0;
                total = _.sum([
                  luCodes?.lu_code_1 ? luCodes?.lu_code_1?.total : 0,
                  luCodes?.lu_code_2 ? luCodes?.lu_code_2?.total : 0,
                  luCodes?.lu_code_3 ? luCodes?.lu_code_3?.total : 0,
                  luCodes?.lu_code_4 ? luCodes?.lu_code_4?.total : 0,
                  luCodes?.lu_code_5 ? luCodes?.lu_code_5?.total : 0,
                  luCodes?.lu_code_6 ? luCodes?.lu_code_6?.total : 0,
                ]);
                const districtInfo = _.find(Districts, {
                  DistrictCode: ap_idn.toString(),
                });

                const provinceInfo = _.find(Provinces, {
                  ProvinceCode: districtInfo?.ProvinceCode,
                });
                const resultObject = {
                  id: id + 1,
                  name: districtInfo ? districtInfo.DistrictName : "",
                  provinceName: provinceInfo ? provinceInfo.ProvinceName : "",
                  ...luCodes,
                  total: total,
                };
                result.push(resultObject);
                id = id + 1;
              });

              let sortedData = result.sort((a: any, b: any) => {
                const provinceComparison = a.provinceName.localeCompare(
                  b.provinceName
                );
                return provinceComparison === 0
                  ? a.name.localeCompare(b.name)
                  : provinceComparison;
              });
              setDataTable(sortedData);
              setTableColumnName("อำเภอ");
              setTotalItems(sortedData.length);
              setOldDataTable(sortedData);
              setDataType("Thailand");
            } else if (params.provinceGroup?.id === 2) {
              let arrayOfResult: any = [];
              let groupData: any = {};
              let groupProvinces = Provinces.filter(
                (p) => p.Group17Provinces === 1
              );
              _.forEach(groupProvinces, (province) => {
                let dataInProvince = data.items.filter(
                  (item) => item.pv_idn === Number(province.ProvinceCode)
                );
                groupData[`${province.ProvinceCode}`] = dataInProvince;
              });

              _.forEach(groupProvinces, (province) => {
                let dataInProvince = groupData[province.ProvinceCode];
                if (dataInProvince.length > 0) {
                  let arrayOfLucode: any = {};
                  let lu_code_1 = dataInProvince.filter(
                    (d: any) => d.lu_code === 1
                  );
                  let lu_code_2 = dataInProvince.filter(
                    (d: any) => d.lu_code === 2
                  );
                  let lu_code_3 = dataInProvince.filter(
                    (d: any) => d.lu_code === 3
                  );
                  let lu_code_4 = dataInProvince.filter(
                    (d: any) => d.lu_code === 4
                  );
                  let lu_code_5 = dataInProvince.filter(
                    (d: any) => d.lu_code === 5
                  );
                  let lu_code_6 = dataInProvince.filter(
                    (d: any) => d.lu_code === 6
                  );

                  if (lu_code_1.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_1, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_1 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_1 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_2.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_2, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_2 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_2 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_3.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_3, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_3 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_3 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_4.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_4, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_4 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_4 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_5.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_5, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_5 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_5 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_6.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_6, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_6 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_6 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }

                  let total = _.sum([
                    arrayOfLucode?.lu_code_1
                      ? arrayOfLucode?.lu_code_1?.total
                      : 0,
                    arrayOfLucode?.lu_code_2
                      ? arrayOfLucode?.lu_code_2?.total
                      : 0,
                    arrayOfLucode?.lu_code_3
                      ? arrayOfLucode?.lu_code_3?.total
                      : 0,
                    arrayOfLucode?.lu_code_4
                      ? arrayOfLucode?.lu_code_4?.total
                      : 0,
                    arrayOfLucode?.lu_code_5
                      ? arrayOfLucode?.lu_code_5?.total
                      : 0,
                    arrayOfLucode?.lu_code_6
                      ? arrayOfLucode?.lu_code_6?.total
                      : 0,
                  ]);
                  arrayOfResult.push({
                    name: province.ProvinceName,
                    total: total,
                    lu_code_1: arrayOfLucode?.lu_code_1,
                    lu_code_2: arrayOfLucode?.lu_code_2,
                    lu_code_3: arrayOfLucode?.lu_code_3,
                    lu_code_4: arrayOfLucode?.lu_code_4,
                    lu_code_5: arrayOfLucode?.lu_code_5,
                    lu_code_6: arrayOfLucode?.lu_code_6,
                  });
                } else {
                  arrayOfResult.push({
                    name: province.ProvinceName,
                    total: 0,
                    lu_code_1: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_2: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_3: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_4: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_5: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_6: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                  });
                }
              });

              setDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
              setOldDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
              setTableColumnName("จังหวัด");
              setTotalItems(arrayOfResult.length);
            } else if (params?.region && params?.region?.RegionCode !== "0") {
              let id = 0;
              const result: any = [];
              let total = 0;
              const groupedData = _.groupBy(
                data.items,
                (item) => `${item.pv_idn}_${item.lu_code}`
              );
              const counts: any = {};
              _.forEach(groupedData, (groupedItems, groupKey) => {
                const [pv_idn, lu_code] = groupKey.split("_");
                if (!counts[pv_idn]) {
                  counts[pv_idn] = {};
                }
                const luCodeObject = counts[pv_idn];
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };

                _.forEach(groupedItems, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                luCodeObject[`lu_code_${lu_code}`] = statusCounts;
              });
              _.forEach(counts, (luCodes, pv_idn) => {
                total = 0;
                total = _.sum([
                  luCodes?.lu_code_1 ? luCodes?.lu_code_1?.total : 0,
                  luCodes?.lu_code_2 ? luCodes?.lu_code_2?.total : 0,
                  luCodes?.lu_code_3 ? luCodes?.lu_code_3?.total : 0,
                  luCodes?.lu_code_4 ? luCodes?.lu_code_4?.total : 0,
                  luCodes?.lu_code_5 ? luCodes?.lu_code_5?.total : 0,
                  luCodes?.lu_code_6 ? luCodes?.lu_code_6?.total : 0,
                ]);
                const provincesInfo = _.find(Provinces, {
                  ProvinceCode: pv_idn.toString(),
                });
                const resultObject = {
                  id: id + 1,
                  name: provincesInfo ? provincesInfo.ProvinceName : "",
                  ...luCodes,
                  total: total,
                };
                result.push(resultObject);
                id = id + 1;
              });
              setDataTable(orderBy(result, ["name"], ["asc"]));
              setOldDataTable(orderBy(result, ["name"], ["asc"]));
              setTableColumnName("จังหวัด");
              setTotalItems(result.length);
              setDataType("Thailand");
            } else {
              let groupedDataItems: any = {
                Central: data.items.filter((e) => e.re_royin === "Central"),
                West: data.items.filter((e) => e.re_royin === "West"),
                East: data.items.filter((e) => e.re_royin === "East"),
                Northeast: data.items.filter((e) => e.re_royin === "Northeast"),
                North: data.items.filter((e) => e.re_royin === "North"),
                South: data.items.filter((e) => e.re_royin === "South"),
              };
              let arrayOfResult: any = [];
              _.forEach(Regions, (region) => {
                let dataInRegions = groupedDataItems[region.RegionCode];
                if (dataInRegions.length > 0) {
                  let arrayOfLucode: any = {};
                  let lu_code_1 = dataInRegions.filter(
                    (d: any) => d.lu_code === 1
                  );
                  let lu_code_2 = dataInRegions.filter(
                    (d: any) => d.lu_code === 2
                  );
                  let lu_code_3 = dataInRegions.filter(
                    (d: any) => d.lu_code === 3
                  );
                  let lu_code_4 = dataInRegions.filter(
                    (d: any) => d.lu_code === 4
                  );
                  let lu_code_5 = dataInRegions.filter(
                    (d: any) => d.lu_code === 5
                  );
                  let lu_code_6 = dataInRegions.filter(
                    (d: any) => d.lu_code === 6
                  );
                  if (lu_code_1.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_1, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_1 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_1 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_2.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_2, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_2 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_2 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_3.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_3, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_3 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_3 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_4.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_4, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_4 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_4 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_5.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_5, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_5 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_5 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_6.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_6, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_6 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_6 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }

                  let total = _.sum([
                    arrayOfLucode?.lu_code_1
                      ? arrayOfLucode?.lu_code_1?.total
                      : 0,
                    arrayOfLucode?.lu_code_2
                      ? arrayOfLucode?.lu_code_2?.total
                      : 0,
                    arrayOfLucode?.lu_code_3
                      ? arrayOfLucode?.lu_code_3?.total
                      : 0,
                    arrayOfLucode?.lu_code_4
                      ? arrayOfLucode?.lu_code_4?.total
                      : 0,
                    arrayOfLucode?.lu_code_5
                      ? arrayOfLucode?.lu_code_5?.total
                      : 0,
                    arrayOfLucode?.lu_code_6
                      ? arrayOfLucode?.lu_code_6?.total
                      : 0,
                  ]);
                  arrayOfResult.push({
                    name: region.RegionName,
                    total: total,
                    lu_code_1: arrayOfLucode?.lu_code_1,
                    lu_code_2: arrayOfLucode?.lu_code_2,
                    lu_code_3: arrayOfLucode?.lu_code_3,
                    lu_code_4: arrayOfLucode?.lu_code_4,
                    lu_code_5: arrayOfLucode?.lu_code_5,
                    lu_code_6: arrayOfLucode?.lu_code_6,
                  });
                } else {
                  arrayOfResult.push({
                    name: region.RegionName,
                    total: 0,
                    lu_code_1: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_2: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_3: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_4: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_5: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_6: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                  });
                }
              });
              setDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
              setTableColumnName("ภูมิภาค");
              setTotalItems(arrayOfResult.length);
              setOldDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
              setDataType("Thailand");
            }
          } else {
            let id = 0;
            const groupedData = _.groupBy(data.items, "ct_tn");
            const result: any = _.map(groupedData, (group, ct_tn) => {
              const VIIRSCount = _.sumBy(group, (item) =>
                item.instrument === "VIIRS" ? item.count_id : 0
              );
              const MODISCount = _.sumBy(group, (item) =>
                item.instrument === "MODIS" ? item.count_id : 0
              );
              const total = VIIRSCount + MODISCount;
              const maxTimestamp = _.maxBy(
                group,
                "max_updated_at"
              )?.max_updated_at;

              id = id + 1;
              return {
                id: id + 1,
                name: ct_tn,
                VIIRS: VIIRSCount,
                MODIS: MODISCount,
                total: total,
                max_timestamp: maxTimestamp,
              };
            });
            setDataTable(orderBy(result, ["name"], ["asc"]));
            setTableColumnName("ประเทศ");
            setTotalItems(result.length);
            setOldDataTable(orderBy(result, ["name"], ["asc"]));
            setDataType("Asean");
          }
        }
      } else {
        setDataTable([]);
        setOldDataTable([]);
      }
      onSetLoading(false);
    } catch (error) {
      onSetLoading(false);
      console.log(error);
    }
  };
  const handleCalculatePagination = (data: any, itemsPerPage: number) => {
    const totalPages = Math.ceil(data.length / itemsPerPage);
    setTotalPage(totalPages);
    setItemStart(0);
    setCurrentPage(1);
    setDataTable(oldDataTable.slice(0, itemsPerPage));
  };
  const handleSelectPage = (page: number) => {
    setCurrentPage(page);
    const startIndex = (page - 1) * limit;
    setItemStart(startIndex);
    const endIndex = startIndex + limit;
    setDataTable(oldDataTable.slice(startIndex, endIndex));
  };
  const { onDownload } = useDownloadExcel({
    currentTableRef: document.querySelector("#data-table"),
    filename: `hotspot-report-${moment(new Date()).format("YYYYMMDDHHmmss")}`,
    sheet: "hotspot",
  });
  const handleFormatTextTitlDataTable = (filter?: FilterType) => {
    if (!filter) {
      let title = "ระดับภูมิภาค";
      setDataTableTitle(title);
    }
    if (filter) {
      if (filter.countryType?.id === 1) {
        let title = "ระดับภูมิภาค";
        if (filter.provinceGroup?.id === 2) {
          title = "ระดับจังหวัด";
        }

        if (filter.region?.RegionCode !== "0") {
          title = "ระดับจังหวัด";
        }
        if (filter.province) {
          const hasProvinceCodeZero = filter.province.some(
            (item) => item.ProvinceCode === "0"
          );
          if (!hasProvinceCodeZero) {
            title = "ระดับอำเภอ";
          }
        }
        if (
          filter.subdistrict?.SubdistrictCode !== "0" ||
          filter.district?.DistrictCode !== "0"
        ) {
          title = "ระดับตำบล";
        }

        setDataTableTitle(title);
      } else if (filter.countryType?.id === 2) {
        let title = "ระดับประเทศ";
        setDataTableTitle(title);
      }
    }
  };

  useEffect(() => {
    getDashboardTable(filterData);
    handleFormatTextTitlDataTable(filterData);
  }, [filterData]);

  useEffect(() => {
    if (totalItems > 0) {
      setHadData(true);
    } else {
      setHadData(false);
    }
  }, [totalItems]);

  useEffect(() => {
    handleCalculatePagination(oldDataTable, limit);
  }, [oldDataTable, limit]);

  useClickOutside(dropdownRef, () => {
    setIsOpenOptionDownLoad(false);
  });

  return (
    <div className="w-full h-full mt-4 bg-primary-contrast flex p-4 md:p-6 flex-col gap-6 rounded-[32px] shadow-z8">
      <div className="hidden md:flex justify-between ">
        <div className="flex gap-2">
          <FilterComponent
            positionClass="left-0 top-0"
            onFilterChanged={handleFilter}
            filters={filterData}
          />
        </div>
        <div className="relative" ref={dropdownRef}>
          <button
            disabled={!hadData}
            onClick={() => handleClickLoad(!isOpenOptionDownLoad)}
            className=" flex gap-2 py-2 px-4 bg-primary-main disabled:bg-gray-1  rounded-xl shadow-z1"
          >
            {!hadData ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 8L7 8C4.79086 8 3 9.79086 3 12L3 17C3 19.2091 4.79086 21 7 21L19 21C21.2091 21 23 19.2091 23 17L23 12C23 9.79086 21.2091 8 19 8L17 8"
                  stroke="#CBCBCB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M10 13L12.2929 15.2929C12.6834 15.6834 13.3166 15.6834 13.7071 15.2929L16 13"
                  stroke="#CBCBCB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M13 15L13 3"
                  stroke="#CBCBCB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 8L7 8C4.79086 8 3 9.79086 3 12L3 17C3 19.2091 4.79086 21 7 21L19 21C21.2091 21 23 19.2091 23 17L23 12C23 9.79086 21.2091 8 19 8L17 8"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M10 13L12.2929 15.2929C12.6834 15.6834 13.3166 15.6834 13.7071 15.2929L16 13"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M13 15L13 3"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            )}
            <p
              className={`${
                !hadData ? "text-text-disabled" : "text-primary-contrast"
              } text-sm font-normal self-center`}
            >
              ดาวน์โหลด
            </p>
          </button>
          {isOpenOptionDownLoad && (
            <div className="absolute w-full top-11 right-0 bg-primary-contrast rounded-xl border-[1px] border-gray-2 flex flex-col p-2">
              {/* <button
                  onClick={() => exportDataToPDF()}
                  className="flex gap-1 py-1 pl-4 pr-2"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 4C4 2.89543 4.89543 2 6 2H10H11.3133C11.9068 2 12.4697 2.26365 12.8497 2.71963L15.5364 5.94373C15.836 6.30316 16 6.75623 16 7.2241V9.5V15C16 16.1046 15.1046 17 14 17H6C4.89543 17 4 16.1046 4 15V4Z"
                      stroke="#5D5D5D"
                      strokeWidth="1.25"
                    />
                    <path
                      d="M12.25 2.37488V5.49988C12.25 6.05216 12.6977 6.49988 13.25 6.49988H15.625"
                      stroke="#5D5D5D"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                    />
                    <path
                      d="M8.07626 12.858C8.35626 12.858 8.56026 12.913 8.68826 13.023C8.81626 13.133 8.88026 13.288 8.88026 13.488C8.88026 13.576 8.86526 13.661 8.83526 13.743C8.80726 13.823 8.76026 13.895 8.69426 13.959C8.62826 14.023 8.54026 14.074 8.43026 14.112C8.32026 14.148 8.18526 14.166 8.02526 14.166H7.77926V15H7.50926V12.858H8.07626ZM8.05226 13.089H7.77926V13.935H7.99526C8.13126 13.935 8.24426 13.921 8.33426 13.893C8.42426 13.863 8.49126 13.816 8.53526 13.752C8.57926 13.688 8.60126 13.604 8.60126 13.5C8.60126 13.362 8.55726 13.259 8.46926 13.191C8.38126 13.123 8.24226 13.089 8.05226 13.089ZM11.0417 13.908C11.0417 14.148 10.9967 14.349 10.9067 14.511C10.8187 14.673 10.6917 14.795 10.5257 14.877C10.3597 14.959 10.1587 15 9.92267 15H9.32567V12.858H9.98567C10.2017 12.858 10.3887 12.898 10.5467 12.978C10.7047 13.058 10.8267 13.176 10.9127 13.332C10.9987 13.486 11.0417 13.678 11.0417 13.908ZM10.7567 13.917C10.7567 13.727 10.7247 13.571 10.6607 13.449C10.5987 13.327 10.5067 13.237 10.3847 13.179C10.2647 13.119 10.1187 13.089 9.94667 13.089H9.59567V14.769H9.88667C10.1767 14.769 10.3937 14.698 10.5377 14.556C10.6837 14.412 10.7567 14.199 10.7567 13.917ZM11.7871 15H11.5171V12.858H12.7141V13.095H11.7871V13.854H12.6571V14.091H11.7871V15Z"
                      fill="#323232"
                    />
                  </svg>
                  <p className="text-sm text-text-primary font-thin">PDF</p>
                </button> */}
              <button
                onClick={onDownload}
                className="flex gap-1 py-1 pl-4 pr-2"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 4C4 2.89543 4.89543 2 6 2H10H11.3133C11.9068 2 12.4697 2.26365 12.8497 2.71963L15.5364 5.94373C15.836 6.30316 16 6.75623 16 7.2241V9.5V15C16 16.1046 15.1046 17 14 17H6C4.89543 17 4 16.1046 4 15V4Z"
                    stroke="#5D5D5D"
                    strokeWidth="1.25"
                  />
                  <path
                    d="M12.25 2.37488V5.49988C12.25 6.05216 12.6977 6.49988 13.25 6.49988H15.625"
                    stroke="#5D5D5D"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                  />
                  <path
                    d="M7.90646 15H6.70946V12.858H7.90646V13.095H6.97946V13.764H7.85246V13.998H6.97946V14.763H7.90646V15ZM8.72145 14.178L8.16645 13.392H8.46645L8.88045 13.998L9.29145 13.392H9.58845L9.03345 14.178L9.61845 15H9.31845L8.88045 14.358L8.43645 15H8.13945L8.72145 14.178ZM10.5733 15.03C10.4313 15.03 10.3043 15.001 10.1923 14.943C10.0823 14.885 9.99534 14.795 9.93134 14.673C9.86934 14.551 9.83834 14.395 9.83834 14.205C9.83834 14.007 9.87134 13.846 9.93734 13.722C10.0033 13.598 10.0923 13.507 10.2043 13.449C10.3183 13.391 10.4473 13.362 10.5913 13.362C10.6733 13.362 10.7523 13.371 10.8283 13.389C10.9043 13.405 10.9663 13.425 11.0143 13.449L10.9333 13.668C10.8853 13.65 10.8293 13.633 10.7653 13.617C10.7013 13.601 10.6413 13.593 10.5853 13.593C10.4773 13.593 10.3883 13.616 10.3183 13.662C10.2483 13.708 10.1963 13.776 10.1623 13.866C10.1283 13.956 10.1113 14.068 10.1113 14.202C10.1113 14.33 10.1283 14.439 10.1623 14.529C10.1963 14.619 10.2473 14.687 10.3153 14.733C10.3833 14.779 10.4683 14.802 10.5703 14.802C10.6583 14.802 10.7353 14.793 10.8013 14.775C10.8693 14.757 10.9313 14.735 10.9873 14.709V14.943C10.9333 14.971 10.8733 14.992 10.8073 15.006C10.7433 15.022 10.6653 15.03 10.5733 15.03ZM11.9907 13.362C12.1287 13.362 12.2467 13.392 12.3447 13.452C12.4447 13.512 12.5207 13.597 12.5727 13.707C12.6267 13.815 12.6537 13.942 12.6537 14.088V14.247H11.5527C11.5567 14.429 11.6027 14.568 11.6907 14.664C11.7807 14.758 11.9057 14.805 12.0657 14.805C12.1677 14.805 12.2577 14.796 12.3357 14.778C12.4157 14.758 12.4977 14.73 12.5817 14.694V14.925C12.4997 14.961 12.4187 14.987 12.3387 15.003C12.2587 15.021 12.1637 15.03 12.0537 15.03C11.9017 15.03 11.7667 14.999 11.6487 14.937C11.5327 14.875 11.4417 14.783 11.3757 14.661C11.3117 14.537 11.2797 14.386 11.2797 14.208C11.2797 14.032 11.3087 13.881 11.3667 13.755C11.4267 13.629 11.5097 13.532 11.6157 13.464C11.7237 13.396 11.8487 13.362 11.9907 13.362ZM11.9877 13.578C11.8617 13.578 11.7617 13.619 11.6877 13.701C11.6157 13.781 11.5727 13.893 11.5587 14.037H12.3777C12.3777 13.945 12.3637 13.865 12.3357 13.797C12.3077 13.729 12.2647 13.676 12.2067 13.638C12.1507 13.598 12.0777 13.578 11.9877 13.578ZM13.3271 15H13.0631V12.72H13.3271V15Z"
                    fill="#323232"
                  />
                </svg>
                <p className="text-sm text-text-primary font-thin">Exel</p>
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col md:hidden gap-2">
        <FilterComponent
          positionClass="left-0 top-0"
          onFilterChanged={handleFilter}
          filters={filterData}
        />
      </div>
      {dataTable !== undefined && dataTable?.length > 0 ? (
        <div className="flex gap-4 flex-col">
          <div id="data-table" className="flex flex-col gap-4">
            <div className="flex justify-between">
              <p className="text-sm text-text-primary font-normal">
                ตารางแสดงรายละเอียด{dataTableTitle}
                <span className="text-xs text-text-secondary">{` (ทั้งหมด: ${oldDataTable.length})`}</span>
              </p>
              {dataDate !== undefined ? (
                <p
                  id={"table-date"}
                  className="text-sm text-text-secondary font-light"
                >
                  {`ปรับปรุงข้อมูลล่าสุดเมื่อ ${moment(new Date(dataDate))
                    .add(543, "years")
                    .format("DD/MM/YYYY")} เวลา ${moment(
                    new Date(dataDate)
                  ).format("HH:mm")} น.`}
                </p>
              ) : (
                ""
              )}
            </div>
            <div className="w-full h-full overflow-x-auto">
              <HotSpotInfoTable
                columnName={tableColumnName}
                hotspot={dataTable}
                dataType={dataType}
                startItem={itemStart}
              />
            </div>
          </div>
          <PagePaginate
            onSelectPage={handleSelectPage}
            onSelectLimit={setLimit}
            currentPage={currentPage}
            totalPage={totalPage}
            itemStart={itemStart}
            limit={limit}
            totalItems={totalItems}
          />
        </div>
      ) : (
        <div className="flex flex-col gap-2 mx-auto h-full justify-center">
          <img
            alt={"imagenot-found"}
            src="/images/report-nofound.svg"
            width={255}
            height={112}
          />
          <p className="text-text-secondary text-xs text-center">
            ค้นหาพื้นที่และช่วงเวลาที่ต้องการ
          </p>
        </div>
      )}
    </div>
  );
}

export default Report;
